import * as React from "react";

/**
 * Logo CFE Auto-Entrepreneur
 * Design institutionnel français : hexagone (forme de la France) + document + accent tricolore
 */
export const CFELogo = ({ className = "", size = 28 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Logo CFE Auto-Entrepreneur"
  >
    {/* Hexagone de fond (forme France stylisée) */}
    <path
      d="M16 2L28 9V23L16 30L4 23V9L16 2Z"
      fill="#F1F5F9"
      stroke="#CBD5E1"
      strokeWidth="1"
    />
    
    {/* Document/Feuille centrale */}
    <rect
      x="10"
      y="8"
      width="12"
      height="15"
      rx="1"
      fill="white"
      stroke="#64748B"
      strokeWidth="1"
    />
    
    {/* Coin plié du document */}
    <path
      d="M18 8V11H22"
      fill="none"
      stroke="#64748B"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M18 8L22 11V8.5C22 8.22 21.78 8 21.5 8H18Z"
      fill="#E2E8F0"
    />
    
    {/* Lignes de texte sur le document */}
    <line x1="12" y1="13" x2="18" y2="13" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
    <line x1="12" y1="16" x2="20" y2="16" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
    <line x1="12" y1="19" x2="17" y2="19" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" />
    
    {/* Bande tricolore stylisée en bas */}
    <rect x="10" y="21" width="4" height="2" fill="#2563EB" rx="0.5" />
    <rect x="14" y="21" width="4" height="2" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="0.5" rx="0.5" />
    <rect x="18" y="21" width="4" height="2" fill="#DC2626" rx="0.5" />
  </svg>
);

/**
 * Version compacte du logo (pour favicon ou espaces restreints)
 */
export const CFELogoCompact = ({ className = "", size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Document simplifié */}
    <rect
      x="4"
      y="2"
      width="16"
      height="20"
      rx="2"
      fill="white"
      stroke="#2563EB"
      strokeWidth="1.5"
    />
    
    {/* Lignes */}
    <line x1="7" y1="8" x2="14" y2="8" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="7" y1="12" x2="17" y2="12" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="7" y1="16" x2="12" y2="16" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" />
    
    {/* Accent tricolore */}
    <rect x="4" y="19" width="5.33" height="3" fill="#2563EB" rx="0 0 0 2" />
    <rect x="9.33" y="19" width="5.33" height="3" fill="#FFFFFF" />
    <rect x="14.66" y="19" width="5.33" height="3" fill="#DC2626" rx="0 0 2 0" />
  </svg>
);

export default CFELogo;
